export default __webpack_public_path__ + "static/media/ttd fbis.87dc1198.png";